import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { TypeTileMembershipFields } from "../../../models/contentful-content-types/tile-membership";
import { ButtonComponent } from "../button/button.component";

@Component({
  standalone: true,
  selector: "jnguyen-tile-membership",
  imports: [CommonModule, ButtonComponent],
  templateUrl: "./tile-membership.component.html",
})
export class TileMembershipComponent {
  @Input() data!: TypeTileMembershipFields;

  documentToHtmlString = documentToHtmlString;

  readonly benefitIconSrc = "/assets/08_Icon_Stichpunkt.png";
}
